<template>
  <div class="">
    <div class="">
      <h1 class="text-2xl font-semibold text-slate-900 dark:text-white">
        احصائيات
      </h1>
    </div>

    <div class="py-2 align-middle inline-block min-w-full mt-6">
      <div class="grid gap-y-10 gap-x-6 md:grid-cols-2 xl:grid-cols-4">
        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المراكز الصحية
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_health_center }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white stroke-current stroke-2"
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask id="a" fill="#fff">
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المسجلين
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_citizen }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white fill-current"
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect width="2.259" height="3.54" x="30.459" y="4.81" />
              <path d="M1.355,16.756" />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              اللقاحات
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_vaccines }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="mw-6 h-6 text-white stroke-current stroke-2"
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 3"
              viewBox="0 0 64 64"
            >
              <path
                d="M51.707,1.293a1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414L50.086,8.5,47,11.586,44.707,9.293a1,1,0,0,0-1.414,0l-29,29a1,1,0,0,0,0,1.414L16.086,41.5l-2.793,2.793a1,1,0,0,0,0,1.414L15.086,47.5,1.293,61.293l1.414,1.414L16.5,48.914l1.793,1.793a1,1,0,0,0,1.414,0L22.5,47.914l1.793,1.793a1,1,0,0,0,1.414,0L44.715,30.7A2.951,2.951,0,0,0,46,31v2H45a4,4,0,0,0-4,4V59a4,4,0,0,0,4,4H57a4,4,0,0,0,4-4V37a4,4,0,0,0-4-4H56V31a3,3,0,0,0,0-6V24a3,3,0,0,0-1.826-2.76l.533-.533a1,1,0,0,0,0-1.414L52.414,17,55.5,13.914l2.793,2.793a1,1,0,0,0,1.414,0l3-3a1,1,0,0,0,0-1.414ZM19,48.586,15.414,45,17.5,42.914,21.086,46.5Zm6-1L16.414,39l13-13H43.78A2.981,2.981,0,0,0,43,28a2.926,2.926,0,0,0,.081.666l-1.374-1.373-1.414,1.414L42.086,30.5,39,33.586l-3.293-3.293-1.414,1.414L37.586,35,34.5,38.086l-1.793-1.793-1.414,1.414L33.086,39.5,30,42.586l-3.293-3.293-1.414,1.414L28.586,44ZM59,55H48V40H59ZM55,35h2a2,2,0,0,1,2,2v1H47a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H59v2a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V37a2,2,0,0,1,2-2h2a1,1,0,0,0,1-1V31h6v3A1,1,0,0,0,55,35Zm2-7a1,1,0,0,1-1,1H46a1,1,0,0,1,0-2H56A1,1,0,0,1,57,28Zm-9-3V24a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v1Zm3.586-4H49a3,3,0,0,0-3,3H31.414L44,11.414,52.586,20ZM51,15.586,48.414,13,51.5,9.914,54.086,12.5Zm8-1L49.414,5,51,3.414,60.586,13Z"
              />
            </svg>
          </div>
        </div>

        <div
          class="relative flex flex-col bg-clip-border rounded-xl bg-white dark:bg-slate-700 dark:text-gray-200 text-gray-700 shadow-md"
        >
          <div class="p-4 text-right">
            <p
              class="block antialiased text-base leading-normal font-normal text-blue-gray-600"
            >
              المستخدمين
            </p>
            <h4
              class="block antialiased tracking-normal font-sans text-2xl font-semibold leading-snug text-blue-gray-900 dark:text-white"
            >
              {{ dashboard_data.total_of_user }}
            </h4>
          </div>

          <div
            class="bg-clip-border mx-4 rounded-xl overflow-hidden bg-gradient-to-tr from-blue-600 to-blue-400 text-white shadow-blue-500/40 shadow-lg absolute left-0 -mt-4 grid h-16 w-16 place-items-center"
          >
            <svg
              class="w-6 h-6 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div class="mt-12">
        <div class="flex justify-between items-center">
          <p class="text-lg font-semibold text-slate-900 dark:text-white">
            أكثر مراكز التطعيم سحب
          </p>

          <p
            class="underline text-base font-semibold text-slate-900 dark:text-white"
          >
            إجمالي اللقاحات في الفترة :

            {{ dashboard_consumed_helth_center_data_total }}
          </p>
        </div>

        <div class="mt-6">
          <p class="text-xl font-semibold text-slate-900 dark:text-white">
            الفترة
          </p>
          <div class="mt-2 flex justify-between items-center">
            <button
              @click="
                period_fun_most_consumed_helth_center(2);
                open_custom_date_most_consumed_helth_center = false;
              "
              :class="
                filter_period_most_consumed_helth_center == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذا اليوم
            </button>

            <button
              @click="
                period_fun_most_consumed_helth_center(3);
                open_custom_date_most_consumed_helth_center = false;
              "
              :class="
                filter_period_most_consumed_helth_center == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذا الشهر
            </button>

            <button
              @click="
                period_fun_most_consumed_helth_center(4);
                open_custom_date_most_consumed_helth_center = false;
              "
              :class="
                filter_period_most_consumed_helth_center == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذه السنة
            </button>

            <button
              @click="
                period_fun_most_consumed_helth_center(1);
                open_custom_date_most_consumed_helth_center = false;
              "
              :class="
                filter_period_most_consumed_helth_center == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الكل
            </button>

            <button
              @click="
                period_fun_most_consumed_helth_center(5);
                open_custom_date_most_consumed_helth_center = true;
              "
              :class="
                filter_period_most_consumed_helth_center == 5
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مخصص
            </button>
          </div>

          <div
            v-if="open_custom_date_most_consumed_helth_center"
            class="mt-2 flex justify-between items-center space-x-reverse space-x-6"
          >
            <div class="input w-1/3 flex items-center">
              <label
                for="filter_most_consumed_helth_center_date_from"
                class="w-12 text-sm font-medium"
              >
                من :
              </label>
              <input
                type="date"
                id="filter_most_consumed_helth_center_date_from"
                placeholder="أكتب تاريخ الميلاد."
                v-model="filter_most_consumed_helth_center_date_from"
                class="mt-1 w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div class="input w-1/3 flex items-center">
              <label
                for="filter_most_consumed_helth_center_date_to"
                class="w-12 text-sm font-medium"
              >
                الي :
              </label>
              <input
                type="date"
                id="filter_most_consumed_helth_center_date_to"
                placeholder="أكتب تاريخ الميلاد."
                v-model="filter_most_consumed_helth_center_date_to"
                class="mt-1 w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div class="w-1/3 cursor-pointer text-white">
              <button
                @click="period_fun_most_consumed_helth_center(5)"
                type="button"
                class="border border-transparent rounded-md shadow-sm w-full py-2 px-16 inline-flex justify-center text-sm font-medium focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                بحث
              </button>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <p class="text-xl font-semibold text-slate-900 dark:text-white">
            تصنيف اللقاح
          </p>
          <div class="mt-2 flex justify-between items-center">
            <button
              @click="
                vaccine_type_period_and_by_citizen_for_helth_center_fun(1)
              "
              :class="
                vaccine_type_period_and_by_citizen_for_helth_center == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الإجباري
            </button>

            <button
              @click="
                vaccine_type_period_and_by_citizen_for_helth_center_fun(2)
              "
              :class="
                vaccine_type_period_and_by_citizen_for_helth_center == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              كبار
            </button>

            <button
              @click="
                vaccine_type_period_and_by_citizen_for_helth_center_fun(3)
              "
              :class="
                vaccine_type_period_and_by_citizen_for_helth_center == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مسافرين
            </button>

            <button
              @click="
                vaccine_type_period_and_by_citizen_for_helth_center_fun(4)
              "
              :class="
                vaccine_type_period_and_by_citizen_for_helth_center == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              حملات
            </button>
            <button
              @click="
                vaccine_type_period_and_by_citizen_for_helth_center_fun(0)
              "
              :class="
                vaccine_type_period_and_by_citizen_for_helth_center == 0
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الكل
            </button>
          </div>
        </div>

        <div class="grid grid-cols-5 mt-6 min-h-60 border border-gray-400">
          <div
            v-for="(x, index) in most_consumeds_helth_center_with_municipals"
            :key="index"
            class="px-4 py-6 border-b border-l border-t-0 border-gray-400 text-center h-full w-full relative group"
          >
            <div class="text-2xl">
              {{ x.total_obtained_Vaccines }}
            </div>
            <div class="">
              {{ x.name }}
            </div>

            <div
              class="hidden group-hover:flex absolute justify-center items-start pt-4 z-20 inset-0 bg-green-300 bg-opacity-10"
            >
              <router-link
                target="_blank"
                title="تقرير اللقاحات"
                :to="{
                  name: 'printPeriodicStatisticsByMuncipal',
                  params: {
                    period: filter_period_most_consumed_helth_center,
                    vaccine_type:
                      vaccine_type_period_and_by_citizen_for_helth_center,
                    id: x.health_center_id,
                    from: filter_most_consumed_helth_center_date_from,
                    to: filter_most_consumed_helth_center_date_to,
                    municipal: municipal_name,
                    vaccinationCenter: x.name,
                  },
                }"
                class="w-8 h-8 text-black hover:text-blue-700 p-2 ml-8 mr-0 focus:outline-none"
              >
                <svg
                  class="fill-current stroke-2 w-8 h-8"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 192.287 192.287"
                  xml:space="preserve"
                >
                  <g>
                    <path
                      d="M122.901,0H19.699v192.287h152.889v-142.6L122.901,0z M146.981,45.299h-19.686V25.612L146.981,45.299z M34.699,177.287V15
		h77.596v37.799c0,4.142,3.357,7.5,7.5,7.5h37.793v116.988H34.699z"
                    />
                    <rect x="53.141" y="149.004" width="86.006" height="10" />
                    <rect x="53.141" y="55.101" width="51.058" height="10" />
                    <polygon
                      points="121.248,86.935 126.79,86.935 105.371,108.353 88.623,91.605 51.597,128.634 58.667,135.706 88.623,105.748 
		105.371,122.495 133.861,94.005 133.861,99.535 143.861,99.535 143.861,76.935 121.248,76.935 	"
                    />
                    <rect x="53.141" y="33.283" width="51.058" height="10" />
                  </g>
                </svg>
              </router-link>

              <router-link
                target="_blank"
                title="تقرير اللقاحات المفصل"
                :to="{
                  name: 'printCitizenVaccinationStatisticsByMuncipal',
                  params: {
                    period: filter_period_most_consumed_helth_center,
                    vaccine_type:
                      vaccine_type_period_and_by_citizen_for_helth_center,
                    id: x.health_center_id,
                    from: filter_most_consumed_helth_center_date_from,
                    to: filter_most_consumed_helth_center_date_to,
                    municipal: municipal_name,
                    vaccinationCenter: x.name,
                  },
                }"
                class="w-8 h-8 text-black hover:text-blue-700 p-2 mr-8 ml-0 focus:outline-none"
              >
                <svg
                  class="fill-current stroke-2 w-8 h-8"
                  version="1.1"
                  id="Capa_1"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 60 60"
                  xml:space="preserve"
                >
                  <g>
                    <g>
                      <path
                        d="M56.5,49L56.5,49V1c0-0.6-0.4-1-1-1h-45c-0.6,0-1,0.4-1,1v14h2V2h43v46h-9c-0.6,0-1,0.4-1,1v9h-33V43h-2v16
			c0,0.6,0.4,1,1,1h35c0.3,0,0.5-0.1,0.7-0.3l10-10c0.1-0.1,0.1-0.2,0.2-0.3v-0.1C56.5,49.2,56.5,49.1,56.5,49z M46.5,50h6.6
			l-3.3,3.3l-3.3,3.3L46.5,50L46.5,50z"
                      />
                      <path
                        d="M16.5,38h6h4v-2h-3V17c0-0.6-0.4-1-1-1h-6c-0.6,0-1,0.4-1,1v6h-5c-0.6,0-1,0.4-1,1v4h-5c-0.6,0-1,0.4-1,1v8
			c0,0.6,0.4,1,1,1h6H16.5z M17.5,18h4v18h-4V24V18z M11.5,25h4v11h-4v-7V25z M5.5,30h4v6h-4V30z"
                      />
                      <path
                        d="M50.5,24V7c0-0.6-0.4-1-1-1h-21c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h21C50.1,25,50.5,24.6,50.5,24z M48.5,12h-12V8h12V12
			z M34.5,8v4h-5c0-1.6,0-4,0-4H34.5z M29.5,14h5v9h-5C29.5,23,29.5,18.3,29.5,14z M36.5,23v-9h12v9H36.5z"
                      />
                      <rect x="28.5" y="28" width="21" height="2" />
                      <rect x="28.5" y="33" width="21" height="2" />
                      <rect x="28.5" y="38" width="21" height="2" />
                      <rect x="14.5" y="6" width="6" height="2" />
                      <rect x="14.5" y="11" width="9" height="2" />
                      <rect x="14.5" y="43" width="7" height="2" />
                      <rect x="24.5" y="43" width="7" height="2" />
                      <rect x="34.5" y="43" width="7" height="2" />
                      <rect x="14.5" y="48" width="7" height="2" />
                      <rect x="24.5" y="48" width="7" height="2" />
                      <rect x="34.5" y="48" width="7" height="2" />
                      <rect x="14.5" y="53" width="7" height="2" />
                      <rect x="24.5" y="53" width="7" height="2" />
                      <rect x="34.5" y="53" width="7" height="2" />
                    </g>
                  </g>
                </svg>
              </router-link>
            </div>
          </div>
        </div>

        <!-- <BarChart :labels="most_consumeds_helth_center_labels" :datasets="most_consumeds_helth_center_datasets"  /> -->
      </div>

      <div class="mt-20">
        <div class="flex justify-between items-center">
          <p class="text-lg font-semibold text-slate-900 dark:text-white">
            أكثر اللقاحات سحب
          </p>

          <p
            class="underline text-base font-semibold text-slate-900 dark:text-white"
          >
            إجمالي اللقاحات في الفترة :

            {{ most_consumed_vaccine_data_total }}
          </p>
        </div>

        <div class="mt-6">
          <p class="text-xl font-semibold text-slate-900 dark:text-white">
            الفترة
          </p>
          <div class="mt-2 flex justify-between items-center">
            <button
              @click="
                period_fun_most_consumed_vaccine(2);
                open_custom_date_most_consumed_vacciner = false;
              "
              :class="
                filter_period_most_consumed_vaccine == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذا اليوم
            </button>

            <button
              @click="
                period_fun_most_consumed_vaccine(3);
                open_custom_date_most_consumed_vacciner = false;
              "
              :class="
                filter_period_most_consumed_vaccine == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذا الشهر
            </button>

            <button
              @click="
                period_fun_most_consumed_vaccine(4);
                open_custom_date_most_consumed_vacciner = false;
              "
              :class="
                filter_period_most_consumed_vaccine == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              هذه السنة
            </button>

            <button
              @click="
                period_fun_most_consumed_vaccine(1);
                open_custom_date_most_consumed_vacciner = false;
              "
              :class="
                filter_period_most_consumed_vaccine == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الكل
            </button>

            <button
              @click="
                period_fun_most_consumed_vaccine(5);
                open_custom_date_most_consumed_vacciner = true;
              "
              :class="
                filter_period_most_consumed_vaccine == 5
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مخصص
            </button>
          </div>

          <div
            v-if="open_custom_date_most_consumed_vacciner"
            class="mt-2 flex justify-between items-center space-x-reverse space-x-6"
          >
            <div class="input w-1/3 flex items-center">
              <label
                for="filter_most_consumed_vaccine_date_from"
                class="w-12 text-sm font-medium"
              >
                من :
              </label>
              <input
                type="date"
                id="filter_most_consumed_vaccine_date_from"
                placeholder="أكتب تاريخ الميلاد."
                v-model="filter_most_consumed_vaccine_date_from"
                class="mt-1 w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div class="input w-1/3 flex items-center">
              <label
                for="filter_most_consumed_vaccine_date_to"
                class="w-12 text-sm font-medium"
              >
                الي :
              </label>
              <input
                type="date"
                id="filter_most_consumed_vaccine_date_to"
                placeholder="أكتب تاريخ الميلاد."
                v-model="filter_most_consumed_vaccine_date_to"
                class="mt-1 w-full border border-solid border-gray-300 rounded-md shadow-sm py-2 px-3 dark:text-gray-200 bg-white dark:bg-gray-600 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              />
            </div>

            <div class="w-1/3 cursor-pointer text-white">
              <button
                @click="period_fun_most_consumed_vaccine(5)"
                type="button"
                class="border border-transparent rounded-md shadow-sm w-full py-2 px-16 inline-flex justify-center text-sm font-medium focus:outline-none bg-blue-600 hover:bg-blue-700 focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
              >
                بحث
              </button>
            </div>
          </div>
        </div>

        <div class="mt-6">
          <p class="text-xl font-semibold text-slate-900 dark:text-white">
            تصنيف اللقاح
          </p>
          <div class="mt-2 flex justify-between items-center">
            <button
              @click="vaccine_type_fun(1)"
              :class="
                most_vaccine_type == 1
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الإجباري
            </button>

            <button
              @click="vaccine_type_fun(2)"
              :class="
                most_vaccine_type == 2
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              كبار
            </button>

            <button
              @click="vaccine_type_fun(3)"
              :class="
                most_vaccine_type == 3
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              مسافرين
            </button>

            <button
              @click="vaccine_type_fun(4)"
              :class="
                most_vaccine_type == 4
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              حملات
            </button>
            <button
              @click="vaccine_type_fun(0)"
              :class="
                most_vaccine_type == 0
                  ? 'bg-green-600 hover:bg-green-700'
                  : 'bg-gray-600 hover:bg-gray-700'
              "
              class="w-1/4 text-center py-2 px-4 border border-transparent text-sm font-medium text-white focus:outline-none"
            >
              الكل
            </button>
          </div>
        </div>

        <div class="grid grid-cols-5 mt-6 min-h-60 border border-gray-400">
          <div
            v-for="(x, index) in most_consumed_vaccine_data"
            :key="index"
            class="px-4 py-6 border-b border-l border-r border-t-0 border-gray-400 text-center h-full w-full"
          >
            <div class="text-2xl">
              {{ x.total_obtained_Vaccines }}
            </div>
            <div class="">
              {{ x.name_ar }}
            </div>
          </div>
        </div>

        <!-- <BarChart :labels="most_consumeds_Vaccine_labels" :datasets="most_consumeds_Vaccine_datasets"  /> -->
      </div>
    </div>
  </div>
</template>

<script>
import Dashboard from "@/services/DashboardService";

// import Statistics from "@/services/StatisticsService";

export default {
  components: {},

  data() {
    return {
      vaccine_type_period_and_by_citizen_for_helth_center: 0,
      most_vaccine_type: 0,

      openedMarkerID: null,

      dashboard_data: {},
      dashboard_consumed_helth_center_data: {},
      dashboard_consumed_vaccine_data: {},

      most_consumeds_helth_center_labels: [],

      most_consumeds_helth_center_datasets: [
        {
          color: "#FFF",
          label: " ",
          backgroundColor: "#3574ef",
          data: [],
        },
      ],

      filter_most_consumed_helth_center_date_from: "",
      filter_most_consumed_helth_center_date_to: "",
      filter_period_most_consumed_helth_center: 2,
      open_custom_date_most_consumed_helth_center: false,

      most_consumeds_Vaccine_labels: [],

      most_consumeds_Vaccine_datasets: [
        {
          color: "#FFF",
          label: " ",
          backgroundColor: "#49cc90",
          data: [],
        },
      ],

      filter_most_consumed_vaccine_date_from: "",
      filter_most_consumed_vaccine_date_to: "",
      filter_period_most_consumed_vaccine: 2,
      open_custom_date_most_consumed_vacciner: false,

      data: [40, 20, 12, 39, 10, 40, 39, 80, 40, 20],

      most_consumeds_helth_center_with_municipals: {},
      most_consumeds_municipals: {},
      most_consumed_vaccine_data: {},

      dashboard_consumed_helth_center_data_total: 0,
      most_consumed_vaccine_data_total: 0,

      municipal_name: this.$store.state.auth.role.name,
    };
  },

  created() {
    this.getDashboardStatisticsNumber();

    var date = new Date();

    var month = date.getMonth() + 1;
    var day = date.getDate();

    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;

    this.filter_most_consumed_helth_center_date_from =
      date.getFullYear() + "-" + month + "-" + day;
    this.filter_most_consumed_helth_center_date_to =
      date.getFullYear() + "-" + month + "-" + day;

    this.filter_most_consumed_vaccine_date_from =
      date.getFullYear() + "-" + month + "-" + day;
    this.filter_most_consumed_vaccine_date_to =
      date.getFullYear() + "-" + month + "-" + day;
  },
  methods: {
    getDashboardStatisticsNumber() {
      let loader = this.$loading.show({
        loader: this.loader,
      });

      Dashboard.getDashboardForMuncipal(this.$store.state.auth.role.guid)
        .then((res) => {
          setTimeout(() => {
            loader.hide();
            this.dashboard_data = res.data;

            this.getDashboardMostConsumedHealthCenter();
            this.getDashboardMostConsumedVaccine();
          }, 10);
        })
        .catch((err) => {
          loader.hide();

          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardMostConsumedHealthCenter() {
      this.dashboard_consumed_helth_center_data = {};
      this.dashboard_consumed_helth_center_data_total = 0;
      this.most_consumeds_helth_center_with_municipals = {};

      if (this.filter_period_most_consumed_helth_center != 5) {
        var date = new Date();

        var month = date.getMonth() + 1;
        var day = date.getDate();

        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        this.filter_most_consumed_helth_center_date_from =
          date.getFullYear() + "-" + month + "-" + day;
        this.filter_most_consumed_helth_center_date_to =
          date.getFullYear() + "-" + month + "-" + day;
      }
      Dashboard.getDashboardMostConsumedHealthCenterForMuncipal(
        this.$store.state.auth.role.guid,
        this.filter_period_most_consumed_helth_center,
        this.filter_most_consumed_helth_center_date_from,
        this.filter_most_consumed_helth_center_date_to,
        true,
        this.vaccine_type_period_and_by_citizen_for_helth_center
      )
        .then((res) => {
          setTimeout(() => {
            this.dashboard_consumed_helth_center_data = res.data;

            this.dashboard_consumed_helth_center_data_total =
              this.dashboard_consumed_helth_center_data.total;

            this.most_consumeds_helth_center_with_municipals =
              this.dashboard_consumed_helth_center_data.list.most_consumeds_helth_center;

            // for (
            //   let index = 0;
            //   index <
            //   this.dashboard_consumed_helth_center_data
            //     .most_consumeds_helth_center.length;
            //   index++
            // ) {
            //   const element =
            //     this.dashboard_consumed_helth_center_data
            //       .most_consumeds_helth_center[index];

            //   this.most_consumeds_helth_center_labels.push(element.name);
            //   this.most_consumeds_helth_center_datasets[0].data.push(
            //     element.total_obtained_Vaccines
            //   );
            // }
          }, 10);
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    getDashboardMostConsumedVaccine() {
      this.dashboard_consumed_vaccine_data = {};
      this.most_consumed_vaccine_data_total = 0;
      this.most_consumed_vaccine_data = {};

      if (this.filter_period_most_consumed_vaccine != 5) {
        var date = new Date();

        var month = date.getMonth() + 1;
        var day = date.getDate();

        if (month < 10) month = "0" + month;
        if (day < 10) day = "0" + day;

        this.filter_most_consumed_vaccine_date_from =
          date.getFullYear() + "-" + month + "-" + day;
        this.filter_most_consumed_vaccine_date_to =
          date.getFullYear() + "-" + month + "-" + day;
      }

      Dashboard.getDashboardMostConsumedVaccineForMuncipal(
        this.$store.state.auth.role.guid,
        this.filter_period_most_consumed_vaccine,
        this.filter_most_consumed_vaccine_date_from,
        this.filter_most_consumed_vaccine_date_to,
        true,
        this.most_vaccine_type
      )
        .then((res) => {
          setTimeout(() => {
            this.dashboard_consumed_vaccine_data = res.data;

            this.most_consumed_vaccine_data_total =
              this.dashboard_consumed_vaccine_data.total;

            this.most_consumed_vaccine_data =
              this.dashboard_consumed_vaccine_data.list.most_consumeds_Vaccine;

            for (
              let index = 0;
              index < this.most_consumed_vaccine_data.length;
              index++
            ) {
              const element = this.most_consumed_vaccine_data[index];

              this.most_consumeds_Vaccine_labels.push(element.name_en);
              this.most_consumeds_Vaccine_datasets[0].data.push(
                element.total_obtained_Vaccines
              );
            }
          }, 10);
        })
        .catch((err) => {
          this.$swal.fire({
            icon: "error",
            title: "...عذرا",
            text: err.response.data.message,
          });
        });
    },

    period_fun_most_consumed_helth_center(p) {
      this.filter_period_most_consumed_helth_center = p;
      this.getDashboardMostConsumedHealthCenter();
    },

    period_fun_most_consumed_vaccine(p) {
      this.filter_period_most_consumed_vaccine = p;
      this.getDashboardMostConsumedVaccine();
    },

    vaccine_type_fun(r) {
      this.most_vaccine_type = r;
      this.getDashboardMostConsumedVaccine();
    },

    vaccine_type_period_and_by_citizen_for_helth_center_fun(r) {
      this.vaccine_type_period_and_by_citizen_for_helth_center = r;
      this.getDashboardMostConsumedHealthCenter();
    },
  },
};
</script>

<style></style>
